import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-5dcb0664"), n = n(), _popScopeId(), n); };
var _hoisted_1 = {
    key: 0,
    class: "w-12 h-12 bg-primary-50 shrink-0 rounded-full chat__avatar default mr-4 flex items-center justify-center"
};
var _hoisted_2 = {
    key: 1,
    class: "w-12 h-12 bg-primary-50 shrink-0 rounded-full chat__avatar default mr-4 flex items-center justify-center"
};
var _hoisted_3 = {
    key: 2,
    class: "w-12 h-12 bg-primary-50 shrink-0 rounded-full chat__avatar default mr-4 flex items-center justify-center"
};
var _hoisted_4 = { class: "flex-grow min-w-0" };
var _hoisted_5 = { class: "flex items-center mb-1" };
var _hoisted_6 = { class: "flex-grow font-medium truncate" };
var _hoisted_7 = { class: "shrink-0 text-sm ml-2 text-gray-400" };
var _hoisted_8 = { class: "flex items-center" };
var _hoisted_9 = { class: "flex-grow text-gray-400 chat__message-text truncate" };
var _hoisted_10 = { key: 0 };
var _hoisted_11 = { key: 1 };
var _hoisted_12 = { key: 2 };
var _hoisted_13 = { key: 3 };
var _hoisted_14 = {
    key: 0,
    class: "shrink-0 py-px px-1.5 ml-2 text-xs text-white rounded-full bg-primary"
};
import dayjs from 'dayjs';
import Avatar from '@common/ui/EAvatar/EAvatar.vue';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ChatLink',
    props: {
        active: { type: Boolean, default: false },
        name: {},
        type: {},
        avatar: {},
        lastMessageTime: {},
        lastMessageFileType: {},
        unreadMessagesCount: {},
        lastMessageText: {},
        user: {},
        isAudio: { type: Boolean }
    },
    emits: ["click"],
    setup: function (__props, _a) {
        var __emit = _a.emit;
        var props = __props;
        var emit = __emit;
        var t = useI18n().t;
        var lastMessageTimeFormatted = computed(function () {
            if (!props.lastMessageTime)
                return;
            var now = dayjs(Date.now()).startOf('day'), messageTime = dayjs(props.lastMessageTime), messageDay = dayjs(props.lastMessageTime).startOf('day'), differentDays = now.diff(messageDay, 'days');
            if (differentDays === 0) {
                return messageTime.format('HH:mm');
            }
            else if (differentDays < 2) {
                return t('chat.yesterday');
            }
            else if (differentDays < 6) {
                return messageTime.format('ddd');
            }
            else {
                return messageTime.format('DD.MM');
            }
        });
        return function (_ctx, _cache) {
            var _component_e_icon = _resolveComponent("e-icon");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass([{
                        'chat--active': _ctx.active
                    }, "flex items-center py-4 px-6 cursor-pointer chat"]),
                onClick: _cache[0] || (_cache[0] = function ($event) { return (emit('click')); })
            }, [
                (_ctx.type === 'course')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode(_component_e_icon, {
                            class: "w-5 h-5 text-primary",
                            icon: "bicolor/chat"
                        })
                    ]))
                    : (_ctx.type === 'group')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createVNode(_component_e_icon, {
                                class: "w-5 h-5 text-primary",
                                icon: "bicolor/users"
                            })
                        ]))
                        : (_ctx.type === 'channel')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                _createVNode(_component_e_icon, {
                                    class: "w-5 h-5 text-primary",
                                    icon: "bicolor/channel"
                                })
                            ]))
                            : (_openBlock(), _createBlock(Avatar, {
                                key: 3,
                                "color-id": _ctx.user ? _ctx.user.id : '',
                                name: _ctx.name,
                                src: _ctx.avatar,
                                class: "chat__avatar shrink-0 default mr-4"
                            }, null, 8, ["color-id", "name", "src"])),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.name), 1),
                        _createElementVNode("p", _hoisted_7, _toDisplayString(lastMessageTimeFormatted.value), 1)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                            (_ctx.lastMessageFileType === 'file')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_unref(t)('chat.file')) + _toDisplayString(_ctx.lastMessageText ? ',' : ''), 1))
                                : (_ctx.lastMessageFileType === 'image')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref(t)('chat.image')) + _toDisplayString(_ctx.lastMessageText ? ',' : ''), 1))
                                    : (_ctx.lastMessageFileType === 'album')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_unref(t)('chat.images')) + _toDisplayString(_ctx.lastMessageText ? ',' : ''), 1))
                                        : (_ctx.isAudio)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_unref(t)('chat.voiceMessage')), 1))
                                            : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(_ctx.lastMessageText), 1)
                        ]),
                        (_ctx.unreadMessagesCount)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.unreadMessagesCount), 1))
                            : _createCommentVNode("", true)
                    ])
                ])
            ], 2));
        };
    }
});
